/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import {
  Box,
  Badge,
  Typography,
  styled,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ButtonBase,
  Divider,
  Stack,
  Drawer,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material';
import Container from '@mui/material/Container';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import { COLOR } from '../../helpers/colors';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    size={12}
    classes={{
      popper: className,
    }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: COLOR.blackColor,
    fontSize: 12,
    padding: 0,
  },
}));

const UserPreferenceSelectionDialog = props => {
  const { open, onClose, title, value, onValueChange, data } = props;
  return (
    <Dialog open={open} onClose={onClose} scroll="paper" fullWidth maxWidth="lg">
      <DialogTitle id="scroll-dialog-title">{title}</DialogTitle>
      <DialogContent dividers>
        <ToggleButtonGroup
          value={value}
          exclusive
          onChange={onValueChange}
          aria-label="text alignment"
          sx={{ width: '100%' }}
        >
          {data.map((d, index) => (
            <ToggleButton
              key={index.toString()}
              style={{
                borderWidth: 0,
                height: 60,
                width: '100%',
                marginTop: 3,
                textAlign: 'left',
              }}
              value={d.code}
            >
              <Box>
                <Typography variant="button" display="block" component="div">
                  {d.label()}
                </Typography>
                <Typography variant="caption" display="block" component="div">
                  {d.code}
                </Typography>
              </Box>
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </DialogContent>
    </Dialog>
  );
};

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLanguageDialog: false,
      showCountryDialog: false,
      showCurrencyDialog: false,
      selectedLanguage: '',
      selectedCurrency: '',
      selectedCountry: '',
      showMobileViewMenu: false,
    };
  }

  componentDidMount = () => {
    const { userPreference } = this.props;
    this.setState({
      ...userPreference,
    });

    this.changeLanguage(userPreference.selectedLanguage);
  };

  handleLanguagesDialogClose = () => {
    this.setState({ showLanguageDialog: false });
  };

  handleLanguagesDialogOpen = () => {
    this.setState({ showLanguageDialog: true });
  };

  handleCountryDialogClose = () => {
    this.setState({ showCountryDialog: false });
  };

  handleCountryDialogOpen = () => {
    this.setState({ showCountryDialog: true });
  };

  handleCurrencyDialogClose = () => {
    this.setState({ showCurrencyDialog: false });
  };

  handleCurrencyDialogOpen = () => {
    this.setState({ showCurrencyDialog: true });
  };

  changeLanguage = lng => {
    const { i18n } = this.props;
    document.body.dir = i18n.dir();
    i18n.changeLanguage(lng);
    document.body.dir = i18n.dir();
  };

  handleLanguageButtonSelection = (event, newSelection) => {
    if (newSelection !== null) {
      const { selectedCountry, selectedCurrency } = this.state;
      this.setState({ selectedLanguage: newSelection, showLanguageDialog: false });
      this.changeLanguage(newSelection);
      this.props.updateUserPreference({
        selectedCountry,
        selectedCurrency,
        selectedLanguage: newSelection,
      });
    }
    this.setState({ showLanguageDialog: false });
  };

  handleCountryButtonSelection = (event, newSelection) => {
    if (newSelection !== null) {
      const { selectedLanguage, selectedCurrency } = this.state;
      this.setState({ selectedCountry: newSelection, showCountryDialog: false });
      this.props.updateUserPreference({
        selectedCurrency,
        selectedLanguage,
        selectedCountry: newSelection,
      });
    }
    this.setState({ showCountryDialog: false });
  };

  handleCurrencyButtonSelection = (event, newSelection) => {
    if (newSelection !== null) {
      const { selectedCountry, selectedLanguage } = this.state;
      this.setState({ selectedCurrency: newSelection, showCurrencyDialog: false });
      this.props.updateUserPreference({
        selectedCountry,
        selectedLanguage,
        selectedCurrency: newSelection,
      });
    }
    this.setState({ showCurrencyDialog: false });
  };

  toggleMobileViewMenu = value => {
    this.setState({ showMobileViewMenu: value });
  };

  renderDialogButtons = () => {
    const { selectedLanguage } = this.state;
    const { languages, countries, currencies } = this.props;

    return (
      <Stack direction="row" alignItems="center">
        {languages ? (
          <ButtonBase
            disableRipple
            onFocus={event => event.stopPropagation()}
            sx={{ pointerEvents: 'auto', marginLeft: 1, marginRight: 1 }}
            onClick={event => {
              event.stopPropagation();
              this.handleLanguagesDialogOpen();
            }}
          >
            <Avatar sx={{ fontSize: 14 }}>{selectedLanguage.toUpperCase().substring(0, 2)}</Avatar>
          </ButtonBase>
        ) : null}
        {countries ? (
          <ButtonBase
            disableRipple
            onFocus={event => event.stopPropagation()}
            sx={{ pointerEvents: 'auto', marginLeft: 1, marginRight: 1 }}
            // onClick={event => {
            //   event.stopPropagation();
            //   this.handleCountryDialogOpen();
            // }}
          >
            <Avatar sx={{ fontSize: 14 }}>
              {this.state.selectedCountry.toUpperCase().substring(0, 3)}
            </Avatar>
          </ButtonBase>
        ) : null}
        {currencies ? (
          <ButtonBase
            disableRipple
            onFocus={event => event.stopPropagation()}
            sx={{ pointerEvents: 'auto', marginLeft: 1, marginRight: 1 }}
            onClick={event => {
              event.stopPropagation();
              this.handleCurrencyDialogOpen();
            }}
          >
            <Avatar sx={{ fontSize: 14 }}>{this.state.selectedCurrency}</Avatar>
          </ButtonBase>
        ) : null}
      </Stack>
    );
  };

  drawerMenu = () => {
    const { showMobileViewMenu } = this.state;
    const {
      history,
      iconsData,
      menuData,
      countries,
      languages,
      currencies,
      width,
      height,
    } = this.props;

    return (
      <Drawer
        anchor="left"
        open={showMobileViewMenu}
        onClose={() => this.toggleMobileViewMenu(false)}
      >
        <Box
          sx={{ width: { xs: '60vw', sm: '40vw' } }}
          role="presentation"
          onClick={() => this.toggleMobileViewMenu(false)}
          onKeyDown={() => this.toggleMobileViewMenu(false)}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ marginX: 1, marginY: 3 }}
          >
            <ButtonBase
              disableRipple
              onClick={event => {
                event.stopPropagation();
                this.toggleMobileViewMenu(false);
                history.push('/');
              }}
            >
              <img
                src="/logo.png"
                alt=""
                loading="lazy"
                onError={e => {
                  e.target.onerror = null;
                  e.target.src = 'https://i.ibb.co/B6phVRm/Image-15.png';
                }}
                width={width}
                height={height}
              />
            </ButtonBase>
            <CloseIcon fontSize="medium" onClick={() => this.toggleMobileViewMenu(false)} />
          </Stack>
          <Divider />
          <List>
            {iconsData.map((d, index) => {
              return (
                <ListItem key={index.toString()} disablePadding>
                  <ListItemButton
                    onClick={e => {
                      this.toggleMobileViewMenu(false);
                      d.onClick(e);
                    }}
                  >
                    <ListItemIcon>
                      <d.icon sx={{ fontSize: { xs: 18, md: 24 } }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={<Typography sx={{ fontSize: { xs: 14 } }}>{d.label()}</Typography>}
                    />
                  </ListItemButton>
                </ListItem>
              );
            })}
            <Divider />
            {menuData.map((d, index) => {
              return (
                <ListItem key={index.toString()} disablePadding>
                  <ListItemButton
                    onClick={() => {
                      d.onClick();
                    }}
                  >
                    <ListItemText
                      primary={<Typography sx={{ fontSize: { xs: 14 } }}>{d.label()}</Typography>}
                    />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
          {currencies || countries || languages ? (
            <Stack>
              <Divider />
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                sx={{ marginX: 1, marginY: 2 }}
              >
                {this.renderDialogButtons()}
              </Stack>
              <Divider />
            </Stack>
          ) : null}
        </Box>
      </Drawer>
    );
  };

  renderWebView = () => {
    const {
      history,
      iconsData,
      countries,
      languages,
      currencies,
      menuData,
      width,
      height,
    } = this.props;
    return (
      <Box>
        <Container>
          <Stack direction="row" marginY={1} justifyContent="space-between" alignItems="center">
            <ButtonBase
              disableRipple
              onClick={event => {
                event.stopPropagation();
                history.push('/');
              }}
            >
              <img
                src="/logo.png"
                alt=""
                loading="lazy"
                onError={e => {
                  e.target.onerror = null;
                  e.target.src = 'https://i.ibb.co/B6phVRm/Image-15.png';
                }}
                width={width}
                height={height}
              />
            </ButtonBase>
            <Stack
              direction="row"
              divider={
                currencies || countries || languages ? (
                  <Divider orientation="vertical" flexItem />
                ) : null
              }
              spacing={2}
            >
              {this.renderDialogButtons()}
              <Stack direction="row" justifyContent="space-evenly" spacing={2} alignItems="center">
                {iconsData.map((d, index) => {
                  return d.showMenu === true && d.body ? (
                    <LightTooltip title={d.body()} key={index.toString()}>
                      <Stack
                        onClick={e => d.onClick(e)}
                        textAlign="center"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          '&:hover': {
                            cursor: 'pointer',
                            color: COLOR.linkColor,
                          },
                        }}
                      >
                        <Badge
                          badgeContent={d.showBadge === true ? d.badgeContent : null}
                          invisible={d.showBadge === true ? d.invisible : true}
                          color="primary"
                        >
                          <d.icon sx={{ fontSize: 18, fontWeight: 800 }} />
                        </Badge>
                        <Typography sx={{ fontSize: 12, fontWeight: 800 }}>{d.label()}</Typography>
                      </Stack>
                    </LightTooltip>
                  ) : (
                    <Stack
                      key={index.toString()}
                      onClick={e => d.onClick(e)}
                      textAlign="center"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        '&:hover': {
                          cursor: 'pointer',
                          color: COLOR.linkColor,
                        },
                      }}
                    >
                      <Badge
                        badgeContent={d.showBadge === true ? d.badgeContent : null}
                        invisible={d.showBadge === true ? d.invisible : true}
                        color="primary"
                      >
                        <d.icon sx={{ fontSize: 18, fontWeight: 800 }} />
                      </Badge>
                      <Typography sx={{ fontSize: 12, fontWeight: 800 }}>{d.label()}</Typography>
                    </Stack>
                  );
                })}
              </Stack>
            </Stack>
          </Stack>
        </Container>
        <Divider />
        {menuData && menuData.length > 0 ? (
          <Stack>
            <Container>
              <Stack direction="row" alignItems="center" spacing={5}>
                {menuData.map((c, index) => (
                  <Stack
                    key={index.toString()}
                    sx={{
                      paddingX: 1,
                      paddingTop: 2,
                      paddingBottom: 1,
                      borderBottom: 5,
                      fontWeight: 600,
                      borderBottomColor: c.isActive ? COLOR.blackColor : 'transparent',
                      '&:hover': {
                        cursor: 'pointer',
                        borderBottomColor: COLOR.blackColor,
                        transition: 'border-bottom 1s ease 0s',
                      },
                    }}
                    alignItems="center"
                    onClick={() => c.onClick()}
                  >
                    <Typography>{c.label()}</Typography>
                  </Stack>
                ))}
              </Stack>
            </Container>
            <Divider />
          </Stack>
        ) : null}
      </Box>
    );
  };

  renderMobileView = () => {
    const { history, width, height } = this.props;
    return (
      <Box>
        <Container>
          <Stack direction="row" marginY={1} justifyContent="space-between" alignItems="center">
            <ButtonBase
              disableRipple
              onClick={event => {
                event.stopPropagation();
                this.toggleMobileViewMenu(false);
                history.push('/');
              }}
            >
              <img
                src="/logo.png"
                alt=""
                loading="lazy"
                onError={e => {
                  e.target.onerror = null;
                  e.target.src = 'https://i.ibb.co/B6phVRm/Image-15.png';
                }}
                width={width}
                height={height}
              />
            </ButtonBase>
            <Stack justifyContent="center">
              <MenuIcon fontSize="large" onClick={() => this.toggleMobileViewMenu(true)} />
            </Stack>
          </Stack>
          {this.drawerMenu()}
        </Container>
        <Divider />
      </Box>
    );
  };

  render() {
    const { t, showHeader, currencies, languages, countries } = this.props;

    return showHeader ? (
      <Stack>
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>{this.renderWebView()}</Box>
        <Box sx={{ display: { xs: 'block', md: 'none' } }}>{this.renderMobileView()}</Box>
        {countries ? (
          <UserPreferenceSelectionDialog
            open={this.state.showCountryDialog}
            onClose={this.handleCountryDialogClose}
            title={t('libraryScreenTranslations:SELECT_COUNTRY')}
            value={this.state.selectedCountry}
            onValueChange={this.handleCountryButtonSelection}
            data={countries}
            t={t}
          />
        ) : null}
        {currencies ? (
          <UserPreferenceSelectionDialog
            open={this.state.showCurrencyDialog}
            onClose={this.handleCurrencyDialogClose}
            title={t('libraryScreenTranslations:SELECT_CURRENCY')}
            value={this.state.selectedCurrency}
            onValueChange={this.handleCurrencyButtonSelection}
            data={currencies}
            t={t}
          />
        ) : null}
        {languages ? (
          <UserPreferenceSelectionDialog
            open={this.state.showLanguageDialog}
            onClose={this.handleLanguagesDialogClose}
            title={t('libraryScreenTranslations:SELECT_LANG')}
            value={this.state.selectedLanguage}
            onValueChange={this.handleLanguageButtonSelection}
            data={languages}
          />
        ) : null}
      </Stack>
    ) : null;
  }
}

export default Header;
